import { Component, Input, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { BehaviorSubject, Subscription } from 'rxjs';
import { CurrentContextService } from 'app/core/current-context.service';

@Component({
  selector: 'app-template-breadcrumb-bar',
  templateUrl: './template-breadcrumb-bar.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./template-breadcrumb-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class TemplateBreadcrumbBarComponent implements OnInit, OnDestroy {
  @Input() public currentItemTextBS: BehaviorSubject<string>;
  @Input() public isTemplateNew: boolean;
  @Input() public isCreateCampaign: boolean;
  @Input() public isAbTest: boolean;

  private currentItemTextSubscription: Subscription;
  private subscriptionArray: Subscription[] = [];
  public currentItemText: string;
  public accountName: string;

  constructor(private readonly currentContextService: CurrentContextService) {}

  ngOnInit() {
    this.currentContextService.currentContextBS.subscribe((currentContext) => {
      if (currentContext) {
        this.accountName = currentContext.account.name;
        if (this.currentItemTextBS) {
          this.currentItemTextSubscription = this.currentItemTextBS.subscribe((text: string) => {
            this.currentItemText = text;
          });
        }
      }
    });
  }

  ngOnDestroy(): void {
    this.subscriptionArray.push(this.currentItemTextSubscription);
    this.subscriptionArray.forEach((subs) => subs && subs.unsubscribe());
  }
}
